export default __webpack_public_path__ + "static/media/coriolis-logo-dark-wide.48471bed.png";